export const walls = [
  // starts top left to right bottom
  [
    [ -16, 26 ],
    [ -16, 25 ],
    [ 10, 20 ],
    [ 10, 21 ],
  ],    
  [
    [ 19, 21 ],
    [ 19, 20 ],
    [ 5, 12 ],
    [ 5, 13 ],
  ],
  [
    [ 0, 14 ],
    [ 0, 15 ],
    [ 5, 13 ],
    [ 5, 12 ],
  ],    
  [
    [ -16, 6.5 ],
    [ -16, 7.5 ],
    [ -12, 5 ],
    [ -12, 4 ],
  ],        
  [
    [ -16, 32 ],
    [ -16, 6.5 ],
    [ -17, 6.5 ],
    [ -17, 32 ],
  ],        
  [
    [ -12, 4 ],
    [ -12, 5 ],
    [ 8, 5.5 ],
    [ 9, 4.5 ],
  ],        
  [
    [ 22, 25 ],
    [ 23, 25 ],
    [ 19, 4 ],
    [ 18, 4 ],
  ],    
  [
    [ 19, 4 ],
    [ 18, 4 ],
    [ 7, 0 ],
    [ 19, 0 ],
  ],        
  // main ground part
  [
    [ 0, -10 ],
    [ -20, -9 ],
    [ 0, -8 ],
    [ 20, -9 ],
  ]
]
